export const hasConsecutiveDigits = (value) => {
  if (!value || value.length < 4) {
    return false;
  }
  const patron = /(.)\1/;
  return !patron.test(value);
};

export const hasSequential = (value) => {
  if (!value || value.length < 4) {
    return false;
  }
  const ascending = '01234567890'.includes(value);
  const descending = '9876543210'.includes(value);

  if (ascending || descending) return false;

  return true;
};

export const checkPinCodeLength = (value) => {
  return value.length > 0 && value.length === 4;
};

export function confirmPinCodeValidation(value, data) {
  if (data.newPin !== data.confirmPin || value === undefined) {
    return 'PROFILE_ERROR_DIFFERENT_PIN';
  }
}